'use client';

import React, { useEffect, useState } from 'react';

import useSWR from 'swr';

import { MonitorEvent } from '@/lib/db/schema'; // your type

import { StatusHistoryChart } from './status-history-chart';
import { StatusHistoryChartSkeleton } from './status-history-chart-skeleton';

const fetcher = (url: string) =>
  fetch(url).then((res) => {
    if (!res.ok) throw new Error('Failed to fetch events');
    return res.json();
  });

type Props = {
  monitorId: number;
  initialEvents?: MonitorEvent[];
};

export function StatusHistoryChartWrapper({ monitorId, initialEvents }: Props) {
  const { data: events, error } = useSWR<MonitorEvent[]>(
    `/api/monitors/${monitorId}/events`,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      refreshInterval: 0,
      dedupingInterval: 60000, // dedupe requests for 60 seconds
      fallbackData: initialEvents,
      revalidateOnMount: !initialEvents,
      suspense: false,
    }
  );

  if (error) return <div>Error loading data</div>;
  if (!events) return <StatusHistoryChartSkeleton />;

  return <StatusHistoryChart monitorEvents={events} />;
}
